
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSApprovalReturnLaborGrid extends Serenity.EntityGrid<POSApprovalReturnLaborRow, any> {
        protected getColumnsKey() { return 'Retail.POSApprovalReturnLabor'; }
        protected getIdProperty() { return POSApprovalReturnLaborRow.idProperty; }
        protected getInsertPermission() { return POSApprovalReturnLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return POSApprovalReturnLaborRow.localTextPrefix; }
        protected getService() { return POSApprovalReturnLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}